import { pestControlService } from '../../helpers/services/productRecommendationPestControl.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUCT_RECOMMENDATION_PEST_CONTROL_MODULE = 'productRecommendationPestControl';

// define action 
export const GET_ALL_PRODUCT_RECOMMENDATION_PEST_CONTROLS = 'getAllProductRecommendationPestControls';
export const GET_PRODUCT_RECOMMENDATION_PEST_CONTROL = 'getProductRecommendationPestControl';
export const UPDATE_PRODUCT_RECOMMENDATION_PEST_CONTROL = 'updateProductRecommendationPestControl';
export const CREATE_PRODUCT_RECOMMENDATION_PEST_CONTROL = 'createProductRecommendationPestControl';
export const UPDATE_PRODUCT_RECOMMENDATION_PEST_CONTROL_STATUS = 'updateProductRecommendationPestControlStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCT_RECOMMENDATION_PEST_CONTROLS_REQUEST = "getAllProductRecommendationPestControls";
const GET_PRODUCT_RECOMMENDATION_PEST_CONTROLS_REQUEST = "getProductRecommendationPestControl";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCT_RECOMMENDATION_PEST_CONTROLS]({ commit }, { filter }) {
        await pestControlService
            .getAllPestControllers(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCT_RECOMMENDATION_PEST_CONTROLS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT_RECOMMENDATION_PEST_CONTROL]({ commit }, { id }) {
        pestControlService
            .getPestControl(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_RECOMMENDATION_PEST_CONTROLS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_RECOMMENDATION_PEST_CONTROL]({ commit }, { data }) {
        commit(REQUEST)
        pestControlService
            .updatePestControl(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS)

                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.pestControl')]);
                    sharedHelper.alertSuccessMessage(message)

                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_RECOMMENDATION_PEST_CONTROL]({ commit }, { data }) {
        commit(REQUEST)
        pestControlService
            .createPestControl(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS)
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.pestControl')]);
                    sharedHelper.alertSuccessMessage(message)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_RECOMMENDATION_PEST_CONTROL_STATUS]({ dispatch }, { filter, data }) {
        pestControlService
            .updatePestControlStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCT_RECOMMENDATION_PEST_CONTROLS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCT_RECOMMENDATION_PEST_CONTROLS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                pestControl: o.pest_control,
                rate: o.rate,
                productRecommendation: o.product_recommendation,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRODUCT_RECOMMENDATION_PEST_CONTROLS_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            pestControl: o.pest_control,
            rate: o.rate,
            productRecommendation: o.product_recommendation,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            productRecommendationID: o.product_recommendation != null ? {
                value: o.product_recommendation.uuid,
                text: o.product_recommendation.name
            } : '',
        }

    }
}


